import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { GlobalStore } from './stores/GlobalStore'

interface StoreProps extends React.PropsWithChildren<unknown> {
  globalStore?: GlobalStore
}

@inject('globalStore')
@observer
export class App extends React.Component<StoreProps, {}> {
  componentDidMount() {
    this.props.globalStore!.connectToServer()
  }

  render() {
    return <div>{this.props.children}</div>
  }
}
